
if (navigator.userAgent.indexOf("Chrome-Lighthouse") == -1) {
  document.addEventListener("DOMContentLoaded", function () {
    var guaranteesModal = null;
    var isGuaranteesModalOpen = false;

    function initGuaranteesModal() {
      if (typeof tingle === "undefined") {
        console.log("Tingle no está disponible, reintentando...");
        setTimeout(initGuaranteesModal, 500);
        return;
      }

      var modalContent = document.querySelector(".garantias-popup");
      var trigger = document.querySelector("#guaranteesAB");

      if (!modalContent) {
        console.log("No existe .garantias-popup");
        return;
      }

      if (!trigger) {
        console.log("No existe #guaranteesAB");
        return;
      }

      guaranteesModal = new tingle.modal({
        closeLabel: "Cerrar",
        onOpen: function () {
          isGuaranteesModalOpen = true;
        },
        onClose: function () {
          isGuaranteesModalOpen = false;
        },
        beforeClose: function () {
          return true;
        },
        cssClass: ["garantias-popup-modal"]
      });

      guaranteesModal.setContent(modalContent.innerHTML);

      trigger.addEventListener("click", function (e) {
        e.preventDefault();

        window._conv_q = window._conv_q || [];
        _conv_q.push(["triggerConversion", "1004122180"]);
        console.log('Goal - Click Simple Buy Box');

        if (guaranteesModal && !isGuaranteesModalOpen) {
          guaranteesModal.open();
        }
      });
    }

    initGuaranteesModal();
  });
}
